import { styled } from '@mui/system';
import * as React from 'react';
import { type ButtonProps } from 'src/components/Button/Button';
import {
  ButtonBase,
  type ButtonBaseProps,
} from 'src/components/ButtonBase/ButtonBase';
import { defaultComponentSizeStyleValues } from 'src/utils/componentSizes';

// eslint-disable-next-line deprecation/deprecation
const UnifyAlertBaseActionRoot = styled(ButtonBase, {
  name: 'UnifyAlertBaseAction',
  slot: 'Root',
})(({ theme }) => {
  const { fontSizeInPx, paddingMultiplier, borderRadiusMultiplier } =
    defaultComponentSizeStyleValues['medium'];

  return {
    fontSize: fontSizeInPx,
    fontWeight: 'bold',
    textDecoration: 'underline',
    padding: theme.spacing(
      paddingMultiplier.vertical,
      // NOTE: This intentionally deviates from standard medium button size horizontal padding
      1
    ),
    borderRadius: theme.spacing(borderRadiusMultiplier),
  };
});

/**
 * @access package
 */
// eslint-disable-next-line deprecation/deprecation
export type AlertBaseActionProps = ButtonBaseProps & Pick<ButtonProps, 'type'>;

/**
 * Used internally by Alert, Banner & Snack
 * @access package
 */
export const AlertBaseAction = React.forwardRef<
  HTMLButtonElement,
  AlertBaseActionProps
>(function AlertBaseAction(props, ref) {
  return (
    <UnifyAlertBaseActionRoot
      ref={ref}
      {...props}
      // @ts-expect-error this prop does work but is block in unify's props
      disableRipple
      disableTouchRipple
    />
  );
});

export default AlertBaseAction;
